import { useIntl } from 'react-intl';

import { roundToOneDecimalIfNecessaryLocale } from 'components/nutrition/utils';
import { useLocale } from 'state/intl';
import { useFlag } from 'state/launchdarkly';
import { LaunchDarklyFlag } from 'utils/launchdarkly';

import { CaloriesSuffix, IUseFormatCalories } from './types';

export function useFormatCalories(): IUseFormatCalories {
  const { formatMessage } = useIntl();
  const { locale } = useLocale();

  const enableNutritionDecimals = useFlag(LaunchDarklyFlag.ENABLE_NUTRITION_DECIMALS);

  return function formatCalories(calories: number | null, suffix: CaloriesSuffix = 'cal'): string {
    const calsString = suffix !== 'none' ? formatMessage({ id: suffix }) : '';

    if ((!calories && calories !== 0) || isNaN(calories)) {
      return '';
    }

    // Old rounding
    const calorieDisplay = enableNutritionDecimals
      ? roundToOneDecimalIfNecessaryLocale(calories, locale)
      : Math.floor(calories).toLocaleString(locale);

    return `${calorieDisplay} ${calsString}`.trim();
  };
}
